<template>
  <div class="history-results mb-2 px-1">
    <div class="his-head-bg mb-2">
      <h2 class="m-0">ຜົນການອອກເລກລາງວັນ</h2>
    </div>
    <table class="table table-bordered mb-1 table-hover">
      <thead>
        <tr>
          <td>ງວດວັນທີ່</td>
          <td width="16%">ເລກ 5 ໂຕ</td>
          <td width="16%">ເລກ 4 ໂຕ</td>
          <td width="16%">ເລກ 3 ໂຕ</td>
          <td width="16%">ເລກ 2 ໂຕ</td>
          <td width="16%">ເລກ 1 ໂຕ</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <span class="full-date">{{ item.lotto_date | date }}</span>
            <span class="short-date">{{ item.lotto_date | shortdate }}</span>
          </td>
          <td>{{ item.results | result('digit5') }}</td>
          <td>{{ item.results | result('digit4') }}</td>
          <td>{{ item.results | result('digit3') }}</td>
          <td>{{ item.results | result('digit2_top') }}</td>
          <td>{{ item.results | result('digit1') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("LL")
    },
    shortdate(param) {
      return moment(param).format("DD/MM/YY")
    },
    result(param, digit) {
      if (param) {
        let results = param
        return results[digit]
      } else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss">
.history-results {
  .his-head-bg {
    background-color: #C60000;
    padding: 8px 0;

    h2 {
      text-align: center;
      font-size: 1.5rem;
      line-height: 1;
      color: #FFF;
      font-weight: normal;
    }
  }

  .table {
    background-color: #FFF;

    tr {
      td {
        padding: 5px;
        text-align: center;

        .short-date {
          display: none;
        }
      }
    }
  }
}

@media only screen and (max-width:500px) {
  .history-results .table tr td {
    .full-date {
      display: none;
    }
    .short-date {
      display: block;
    }
  }
}
</style>
